/** @format **/
import React, { FunctionComponent } from 'react';
import { TableCell, TableRow, withStyles } from '@material-ui/core';
import EditButton from '../../components/Buttons/EditButton';
import I18n from '../../components/Translate/I18n';
import MvnoBlockListInterface from '../../interfaces/platform/MvnoBlockListInterface';
import { DateHelperTs } from '../../helpers/DateHelperTs';
import { PlatformResellerCollectionInterface } from '../../interfaces/collections/PlatformResellerCollectionInterface';
import { roles, UserRoleHelper } from '../../helpers/UserRoleHelper';
import OPL_STYLE from '../../assets/themes/OPL/OplStyle';
import oplAppStyle from '../../assets/themes/OPL/jss/App/OplAppStyle';
import CloneButton from '../../components/Buttons/CloneButton';
import BlockButton from '../../components/Buttons/BlockButton';

type MvnoBlockListItemType = {
    classes: any;
    item: MvnoBlockListInterface;
    setActiveRow: (id: number) => void;
    activeRow: number;
    viewCallback: (iri: { uri: string }, event: any) => void;
    lockCallback: (iri: { uri: string; lockFlag: boolean }, event: any) => void;
    platformResellerCollection: PlatformResellerCollectionInterface | null;
    openClone(blockName: string, blockId: number): void;
};

const MvnoBlockListItem: FunctionComponent<MvnoBlockListItemType> = ({
    classes,
    item,
    activeRow,
    setActiveRow,
    viewCallback,
    platformResellerCollection,
    openClone,
    lockCallback,
}): React.ReactElement => {
    const tableControlStickyHeader = { root: classes.tableControlStickyHeader };
    const tableCellRoot = { root: classes.tableCellRootBordered };
    const tableRowRoot = { root: classes.tableRowRoot };

    let rowActiveColor = 'white';
    if (activeRow === item.id) {
        rowActiveColor = OPL_STYLE.TABLE.ACTIVE_ROW;
    }

    const getResellerName = (platformResellerId: number): string => {
        let name = '';
        if (platformResellerCollection) {
            for (let i = 0; i < platformResellerCollection['hydra:member'].length; i++) {
                if (platformResellerCollection['hydra:member'][i].id === platformResellerId) {
                    return platformResellerCollection['hydra:member'][i].mainname;
                }
            }
        }
        return name;
    };

    return (
        <TableRow
            classes={tableRowRoot}
            key={'key' + item.id}
            hover
            onClick={(): void => {
                setActiveRow(item.id);
            }}
            style={{ backgroundColor: rowActiveColor }}
        >
            <TableCell classes={tableControlStickyHeader} padding="none" align="left" style={{ backgroundColor: rowActiveColor }}>
                {UserRoleHelper.checkRole(roles.ROLE_PLATFORM_BLOCK_CONTAINS_GET) && (
                    <EditButton
                        callback={viewCallback}
                        callbackParam={{ uri: item['@id'] }}
                        tooltipTitle="prov:vb.edit_block"
                        tooltipPlacement="bottom-start"
                    />
                )}
                {UserRoleHelper.checkRole(roles.ROLE_PLATFORM_BLOCK_CONTAINS_POST) && (
                    <>
                        <CloneButton
                            callback={(): void => openClone(item.blockName, item.id)}
                            callbackParam={{ uri: item['@id'] }}
                            tooltipTitle="prov:vb.clone_block"
                            tooltipPlacement="bottom-start"
                        />
                        {!item.defaultGlobal && !item.lockFlag && (
                            <BlockButton
                                callback={lockCallback}
                                callbackParam={{ uri: item['@id'], lockFlag: true }}
                                tooltipTitle="prov:vb.lock_block"
                                tooltipPlacement="bottom-start"
                            />
                        )}
                        {!item.defaultGlobal && item.lockFlag && (
                            <BlockButton
                                callback={lockCallback}
                                callbackParam={{ uri: item['@id'], lockFlag: false }}
                                tooltipTitle="prov:vb.unlock_block"
                                tooltipPlacement="bottom-start"
                            />
                        )}
                    </>
                )}
            </TableCell>
            <TableCell classes={tableCellRoot} padding="none" align="left">
                {item.blockName}
            </TableCell>
            <TableCell classes={tableCellRoot} padding="none" align="left">
                {getResellerName(item.platformResellerId)}
            </TableCell>
            <TableCell classes={tableCellRoot} padding="none" align="left">
                {<I18n trans={item.defaultGlobal ? 'general:common.yes' : 'general:common.no'} />}
            </TableCell>
            <TableCell classes={tableCellRoot} padding="none" align="left">
                {DateHelperTs.format(item.createdAt, 'YYYY-MM-DD')}
            </TableCell>
            <TableCell classes={tableCellRoot} padding="none" align="left">
                {item.deletedAt && DateHelperTs.format(item.deletedAt, 'YYYY-MM-DD')}
            </TableCell>
            <TableCell classes={tableCellRoot} padding="none" align="left">
                {<I18n trans={!item.deleted ? 'general:common.yes' : 'general:common.no'} />}
            </TableCell>
        </TableRow>
    );
};

export default withStyles(oplAppStyle)(MvnoBlockListItem);
